import { render } from "./activity-index.vue?vue&type=template&id=53192046&scoped=true"
import script from "./activity-index.vue?vue&type=script&lang=js"
export * from "./activity-index.vue?vue&type=script&lang=js"

import "./activity-index.vue?vue&type=style&index=0&id=53192046&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53192046"]])

export default __exports__